import React from 'react';
import PropTypes from 'prop-types';
import { CONSTANT_VARIABLES } from '../../views/common/Constant_Variables/constants';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  // semi-transparent dark overlay + blur of background
  background: 'rgba(0,0,0,0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2147483647,
  pointerEvents: 'auto',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)',
};

const boxStyle = {
  background: 'rgba(255,255,255,0.98)',
  padding: 24,
  width: '92%',
  maxWidth: 760,
  borderRadius: 8,
  boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
  border: '1px solid rgba(0,0,0,0.08)',
};

const titleStyle = {
  marginTop: 0,
  marginBottom: 12,
  fontSize: 18,
  fontWeight: 700,
  textTransform: 'uppercase',
};

const paragraphStyle = {
  color: '#333',
  lineHeight: 1.45,
  fontSize: 14,
  marginBottom: 16,
};

const linkStyle = {
  color: '#0078d4',
  textDecoration: 'underline',
  cursor: 'pointer',
};

const actionsStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 12,
  marginTop: 8,
};

const rejectButtonStyle = {
  background: '#fff',
  color: '#f47c20',
  border: '2px solid #f47c20',
  padding: '8px 18px',
  borderRadius: 4,
  cursor: 'pointer',
};

const acceptButtonStyle = {
  background: '#f47c20',
  color: '#fff',
  border: 'none',
  padding: '8px 18px',
  borderRadius: 4,
  cursor: 'pointer',
};

export default function ConsentModal({ onAccept, onReject, dismissedButBlurred }) {
  // When dismissedButBlurred is true we keep the overlay visible and blocking
  // interactions but hide the dialog box content itself.
  return (
    <div style={overlayStyle} role="dialog" aria-modal={!dismissedButBlurred} aria-hidden={false}>
      {!dismissedButBlurred && (
        <div style={boxStyle}>
          <h2 style={titleStyle}>{CONSTANT_VARIABLES.PRIVACY_POLICY_CONSENT_TITLE}</h2>
          <div style={paragraphStyle}>
            {CONSTANT_VARIABLES.PRIVACY_POLICY_CONSENT_MESSAGE}{' '}
            <a
              href={CONSTANT_VARIABLES.PRIVACY_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              {CONSTANT_VARIABLES.PRIVACY_POLICY_LABEL}
            </a>
            .
          </div>
          <div style={actionsStyle}>
            <button type="button" onClick={onReject} style={rejectButtonStyle}>
              Reject
            </button>
            <button type="button" onClick={onAccept} style={acceptButtonStyle}>
              Accept
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

ConsentModal.propTypes = {
  onAccept: PropTypes.func.isRequired,
  onReject: PropTypes.func,
};

ConsentModal.defaultProps = {
  onReject: () => {},
};
